import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    Text,
    VStack,
    Link,
} from '@chakra-ui/react'
import { Icon } from '@chakra-ui/icons'
import { FaMagic } from 'react-icons/fa'

interface MaxSuggestionsModalProps {
    isOpen: boolean
    onClose: () => void
}

export const MaxSuggestionsModal: React.FC<MaxSuggestionsModalProps> = ({
    isOpen,
    onClose,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <VStack spacing={2} align="center">
                        <Icon as={FaMagic} fontSize="3xl" color="purple.500" />
                        <Text>AI Suggestions Limit Reached</Text>
                    </VStack>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <Text textAlign="center">
                            You've reached the maximum number of AI suggestions
                            included in your current plan. This feature is still
                            free while in beta, so it is limited to 300
                            suggestions in a 30 day period.
                        </Text>
                        {/* <Text
                            textAlign="center"
                            fontSize="lg"
                            fontWeight="bold"
                            color="purple.600"
                        >
                            Upgrade to unlimited AI responses for just $59/month
                        </Text> */}
                        <Text textAlign="center">
                            To add unlimited AI suggestions to your plan, please
                            reach out to our support team at{' '}
                            <Link
                                href="mailto:support@chckvet.com"
                                color="purple.500"
                                fontWeight="semibold"
                                isExternal
                            >
                                support@chckvet.com
                            </Link>
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="purple" onClick={onClose} w="full">
                        Got it
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
